import usePageMeta from "utils/usePageMeta";
// Material Kit 2 React components
import MKBox from "components/MKBox";

// Layout
import SubPageLayout from "reusables/layouts/SubPageLayout";

// Sections
import EndOfTenancy_Section1 from "./sections/EndOfTenancy_Section1";
import EndOfTenancy_Section2 from "./sections/EndOfTenancy_Section2";
import EndOfTenancy_Section3 from "./sections/EndOfTenancy_Section3";

function EndOfTenancyCleaning() {
  usePageMeta({
    title: "End of Tenancy Cleaning Ireland | Spechs",
    description:
      "Professional end of tenancy cleaning across Ireland. Thorough, reliable, and deposit-friendly.",
    canonical: "https://www.spechs.ie/cleaning/tenancy/",
  });
  return (
    <SubPageLayout title="End of Tenancy Cleaning">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <EndOfTenancy_Section1 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <EndOfTenancy_Section2 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <EndOfTenancy_Section3 />
      </MKBox>
    </SubPageLayout>
  );
}

export default EndOfTenancyCleaning;
